<div *ngIf="movie && movie; else loadingBlock">
  <div class="header">
    <div class="title">
      <mat-label [routerLink]="['/admin/ratings']" routerLinkActive="router-link-active">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
        <h2>Votes</h2>
      </mat-label>
    </div>
  </div>
  <div *ngIf="!movie.subMovies">
    <div class="rates">
      <div class="rate">
        <h1>
          {{ movie.title }}
        </h1>
        <img class="detail" [src]="movie.attach" />
      </div>
      <div class="rate">
        <app-voting-bars [id]="id" [starSize]="70" (ratingEvent)="valueUpdated($event)"></app-voting-bars>
        <div class="button-div">
          <button mat-raised-button [disabled]="!movie.canVote" (click)="askVote()">Voter</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="movie.subMovies">
    <h1>
      {{ movie.title }}
    </h1>
    <div class="rates">
      <div *ngFor="let subMovie of movie.subMovies">
        <mat-card>
          <div class="rate">
            <mat-card-header>
              <mat-card-title>{{ subMovie.title }}</mat-card-title>
            </mat-card-header>
            <div class="flex-div">
              <img mat-card-lg-image [src]="subMovie.attach" />

            </div>
          </div>
          <div class="rate">
            <app-voting-bars [id]="subMovie.id" [starSize]="40" (ratingEvent)="valueUpdated($event)" ></app-voting-bars>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="button-div">
      <button mat-raised-button  [disabled]="!movie.canVote" (click)="askVote()">Voter</button>
    </div>
  </div>
</div>

<ng-template #loadingBlock>
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="30"></mat-progress-spinner>
</ng-template>